export interface ScrollAnchor {
  id: string;
  top: number;
}

export interface LaneEdgeKeys {
  firstKey?: string;
  lastKey?: string;
}

export type AnchorAction =
  | 'restore'
  | 'clear'
  | 'none';

export const laneEdgeKeys = (
  items: ReadonlyArray<{ itemKey?: string }> | undefined | null
): LaneEdgeKeys => {
  const list = items ?? [];
  return { firstKey: list[0]?.itemKey, lastKey: list[list.length - 1]?.itemKey };
};

export const resolveAnchorAction = (
  hasAnchor: boolean,
  prev: LaneEdgeKeys,
  next: LaneEdgeKeys
): AnchorAction => {
  const firstChanged = prev.firstKey !== next.firstKey;
  const lastChanged = prev.lastKey !== next.lastKey;
  if (hasAnchor && firstChanged) return 'restore';
  if (lastChanged) return 'clear';
  return 'none';
};

export const restoreScrollTop = (
  scrollTop: number,
  anchorTop: number,
  currentTop: number
): number => scrollTop + (currentTop - anchorTop);
